import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      const dest = res.user.role === "admin" ? "/admin" : (location.state?.from || "/dashboard");
      navigate(dest, { replace: true });
    } else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-64px)] grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-ink text-bone">
        <div className="label-eyebrow text-bone/70">Carolina Peer Institute</div>
        <div>
          <h1 className="font-serif text-5xl leading-[1.05] mb-6">
            Welcome back to the work.
          </h1>
          <p className="text-bone/80 max-w-[40ch] leading-relaxed">
            Pick up where you left off. Your progress, your modules, and your certificate
            of completion are waiting.
          </p>
        </div>
        <div className="label-eyebrow text-bone/50">40 hours · 12 modules · NC standard</div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div className="label-eyebrow">Sign in</div>
          <h2 className="font-serif text-4xl text-ink">Continue your training</h2>
          {error && (
            <div className="bg-rust/10 border border-rust/40 text-rust px-4 py-3 text-sm" data-testid="login-error">
              {error}
            </div>
          )}
          <label className="block">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-stone bg-white px-4 py-3 focus:outline-none focus:border-ink text-ink"
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Password</span>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-stone bg-white px-4 py-3 focus:outline-none focus:border-ink text-ink"
              data-testid="login-password"
            />
          </label>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-muted-foreground">
            New here? <Link to="/register" className="text-ink underline underline-offset-4" data-testid="login-to-register">Enroll instead</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
